export const entitiesSelector = state => state.entities;
export const userEntitiesSelector = state => state.entities.users;
export const anchorEntitiesSelector = state => state.entities.anchors;
export const feedEntitiesSelector = state => state.entities.feeds;
export const feedItemsEntitiesSelector = state => state.entities.feedItems;
export const activityEntitiesSelector = state => state.entities.activities;
export const roomEntitiesSelector = state => state.entities.rooms;
export const presenceEntitiesSelector = state => state.entities.presences;
export const feedMembersEntitiesSelector = state => state.entities.feedMembers;
